var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cart_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.373,
    height: 21.381,
    viewBox: "0 0 21.373 21.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M19.882,25.537H7.547A4.5,4.5,0,0,1,3.99,23.788a4.551,4.551,0,0,1-.81-3.9L5.68,9.628A.823.823,0,0,1,6.5,9H20.277a.823.823,0,0,1,.822.579l3.109,10.055a4.56,4.56,0,0,1-.683,4.06,4.441,4.441,0,0,1-3.643,1.844ZM7.119,10.654,4.742,20.287a2.907,2.907,0,0,0,.517,2.475,2.873,2.873,0,0,0,2.255,1.122H19.849a2.824,2.824,0,0,0,2.294-1.174,2.907,2.907,0,0,0,.436-2.588l-2.895-9.468Z",
    transform: "translate(-3.041 -4.156)",
    fill: "#fc2779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M18.265,14.3a.807.807,0,0,1-.807-.807V7.036a2.422,2.422,0,1,0-4.844,0v6.458a.807.807,0,0,1-1.615,0V7.036a4.036,4.036,0,0,1,8.073,0v6.458A.807.807,0,0,1,18.265,14.3Z",
    transform: "translate(-4.38 -3)",
    fill: "#fc2779"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart1);
export default __webpack_public_path__ + "static/media/cart_1.aaaa0e8f40a64127719dd22d95f8e102.svg";
export { ForwardRef as ReactComponent };